/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { INodeProps, Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ISingleOrderTemplateViewProps } from './components';
import { IOrderTemplateListViewProps } from './order-template-list';

export const OrderTemplateListView: React.FC<IOrderTemplateListViewProps> = props => {
    const {
        OrderTemplateList,
        status,
        statusMessage,
        heading,
        OrderTemplates,
        orderTemplates,
        OrderTemplate,
        createOrderTemplateButton,
        templateHeaderStatusMessage
    } = props;

    return (
        <Module {...OrderTemplateList}>
            {heading}
            {status !== 'SUCCESS' && statusMessage}
            <Node className=''>
                {createOrderTemplateButton}
                {templateHeaderStatusMessage}
            </Node>
            {OrderTemplates && orderTemplates && orderTemplates.length > 0 && (
                <Node {...OrderTemplates}>
                    {orderTemplates &&
                        orderTemplates.map(orderTemplate => {
                            return _renderOrderTemplate(orderTemplate, OrderTemplate);
                        })}
                </Node>
            )}
        </Module>
    );
};

const _renderOrderTemplate = (orderTemplate: ISingleOrderTemplateViewProps, OrderTemplate?: INodeProps): JSX.Element | null => {
    const { key, addToCartButton, orderTemplateImage, orderTemplateStatusMessage, removeButton, orderTemplateName } = orderTemplate;
    return (
        <Node key={key} className={OrderTemplate!.className} {...OrderTemplate}>
            {orderTemplateName}
            {orderTemplateImage}
            {addToCartButton}
            {removeButton}
            {orderTemplateStatusMessage}
        </Node>
    );
};

export default OrderTemplateListView;
